<div class="header">
    <div class="title">
        <h3>{{'home.teamMembers' | translate}}</h3>
    </div>
</div>
<div class="container mt-5 container-min-hight">
    <div class="row">
        <div class="col-lg-4">
            <div class="image-flip" >
                <div class="mainflip">
                    <div class="frontside">
                        <div class="card">
                            <div class="card-body text-center">
                                <!-- <img class=" img-fluid" src="../../../../assets/imgs/dr.yousef.jpg" alt="card image"> -->
                                <h3 class="card-title">د. يوسف سلامة</h3>
                                <p class="card-text">المدير العام</p>
                            </div>
                        </div>
                    </div>
                    <div class="backside">
                        <div class="card">
                            <div class="card-body text-center mt-4">
                                <h4 class="card-title">د. يوسف سلامة</h4>
                                <p class="card-text">المدير العام</p>
                                <p class="card-text">حريصون على التطور الدائم والبحث دائماً عن الحلول التقنية للمشاكل التي تواجه الناس  في تعاملاتهم اليومية والعملية</p>
                                <ul class="list-inline">
                                    <li class="list-inline-item">
                                        <a class="social-icon text-xs-center" target="_blank" href="#">
                                            <i class="fa fa-facebook"></i>
                                        </a>
                                    </li>
                                    <li class="list-inline-item">
                                        <a class="social-icon text-xs-center" target="_blank" href="#">
                                            <i class="fa fa-twitter"></i>
                                        </a>
                                    </li>
                                    <li class="list-inline-item">
                                        <a class="social-icon text-xs-center" target="_blank" href="#">
                                            <i class="fa fa-skype"></i>
                                        </a>
                                    </li>
                                    <li class="list-inline-item">
                                        <a class="social-icon text-xs-center" target="_blank" href="#">
                                            <i class="fa fa-google"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4">
            <div class="image-flip" >
                <div class="mainflip">
                    <div class="frontside">
                        <div class="card">
                            <div class="card-body text-center">
                                <!-- <img class=" img-fluid" src="../../../../assets/imgs/m.elsayed.jpg" alt="card image"> -->
                                <h3 class="card-title">م. محمد السيد</h3>
                                <p class="card-text">مدير التطبيق</p>
                            </div>
                        </div>
                    </div>
                    <div class="backside">
                        <div class="card">
                            <div class="card-body text-center mt-4">
                                <h4 class="card-title">م. محمد السيد</h4>
                                <p class="card-text">مدير التطبيق</p>
                                <p class="card-text">التواصل الدائم مع العملاء وسماع العقبات التي تواجهم في استخدام التطبيق ومن ثم البحث عن الحلول التقنية لتلك المشاكل وتحويل تلك العقبات لمهام تقنية وتوزيعها على فريق عمل التطبيق  </p>
                                <ul class="list-inline">
                                    <li class="list-inline-item">
                                        <a class="social-icon text-xs-center" target="_blank" href="#">
                                            <i class="fa fa-facebook"></i>
                                        </a>
                                    </li>
                                    <li class="list-inline-item">
                                        <a class="social-icon text-xs-center" target="_blank" href="#">
                                            <i class="fa fa-twitter"></i>
                                        </a>
                                    </li>
                                    <li class="list-inline-item">
                                        <a class="social-icon text-xs-center" target="_blank" href="#">
                                            <i class="fa fa-skype"></i>
                                        </a>
                                    </li>
                                    <li class="list-inline-item">
                                        <a class="social-icon text-xs-center" target="_blank" href="#">
                                            <i class="fa fa-google"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4">
            <div class="image-flip" >
                <div class="mainflip">
                    <div class="frontside">
                        <div class="card">
                            <div class="card-body text-center">
                                <!-- <img class=" img-fluid" src="../../../../assets/imgs/m.helpawy.jpeg" alt="card image"> -->
                                <h3 class="card-title">م. محمد الهلباوي</h3>
                                <p class="card-text">المدير التقني للتطبيق</p>
                            </div>
                        </div>
                    </div>
                    <div class="backside">
                        <div class="card">
                            <div class="card-body text-center mt-4">
                                <h4 class="card-title">م. محمد الهلباوي</h4>
                                <p class="card-text">المدير التقني للتطبيق</p>
                                <p class="card-text">استلام المهام التقنية و البدأ في عملية البحث عن افضل الحلول التقنية التي وصلت لها التقنيات الحديثة</p>
                                <ul class="list-inline">
                                    <li class="list-inline-item">
                                        <a class="social-icon text-xs-center" target="_blank" href="#">
                                            <i class="fa fa-facebook"></i>
                                        </a>
                                    </li>
                                    <li class="list-inline-item">
                                        <a class="social-icon text-xs-center" target="_blank" href="#">
                                            <i class="fa fa-twitter"></i>
                                        </a>
                                    </li>
                                    <li class="list-inline-item">
                                        <a class="social-icon text-xs-center" target="_blank" href="#">
                                            <i class="fa fa-skype"></i>
                                        </a>
                                    </li>
                                    <li class="list-inline-item">
                                        <a class="social-icon text-xs-center" target="_blank" href="#">
                                            <i class="fa fa-google"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-3">
            <div class="frontside">
                <div class="card">
                    <div class="card-body text-center">
                        <!-- <img class=" img-fluid" src="../../../../assets/imgs/3-cell.png" alt="card image"> -->
                        <h4 class="card-title">م. أحمد علام</h4>
                        <p class="card-text">SR. Full stack Developer</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-3">
            <div class="frontside">
                <div class="card">
                    <div class="card-body text-center">
                        <!-- <img class=" img-fluid" src="../../../../assets/imgs/a.adawy.jpg" alt="card image"> -->
                        <h4 class="card-title">م. أحمد العدوي</h4>
                        <p class="card-text">SR. Full stack Developer</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-3">
            <div class="frontside">
                <div class="card">
                    <div class="card-body text-center">
                        <!-- <img class=" img-fluid" src="../../../../assets/imgs/yousef.jpg" alt="card image"> -->
                        <h4 class="card-title">م. يوسف صالح</h4>
                        <p class="card-text">SR. Full stack Developer</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-3">
            <div class="frontside">
                <div class="card">
                    <div class="card-body text-center">
                        <!-- <img class=" img-fluid" src="../../../../assets/imgs/1-cell.png" alt="card image"> -->
                        <h4 class="card-title">م. مصطفى</h4>
                        <p class="card-text">SR. Full stack Developer</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
